import { tiltTraderConfig } from "../tilttrader-config";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const TokenProcessing = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  // Extract query params
  const params = new URLSearchParams(search);
  const loginToken = params.get("token1");
  const is_dark_mode_on = params.get("is_dark_mode_on");

  // Build WebSocket URL
  const url = `wss://ws.derivws.com/websockets/v3?app_id=${tiltTraderConfig.appId}`;

  // Get message from WebSocket
  const message = useWebSocket(url, loginToken);

  // Redirect only when we have valid message
  useEffect(() => {
    if (!message) return; // still waiting for response

    const { loginid, currency } = message;

    if (!loginid || !currency) return; // invalid data

    navigate(
      `/?token1=${loginToken}&acct1=${loginid}&cur1=${currency}&is_dark_mode_on=${is_dark_mode_on}`,
      { replace: true }
    );
  }, [message, navigate, loginToken, is_dark_mode_on]);

  // Simple loading UI
  return (
    <div className="h-screen justify-center items-center text-center">
      Processing token...
    </div>
  );
};

function useWebSocket(url, loginToken) {
  const socketRef = useRef(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (!url) return;

    // Create WebSocket connection
    socketRef.current = new WebSocket(url);
    let authorizeData = null;

    // On message
    socketRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);

      switch (data.msg_type) {
        case "authorize": {
          const { loginid, currency } = data.authorize;
          socketRef.current.send(JSON.stringify({ get_settings: 1 }));
          authorizeData = { loginid, currency, loginToken };
          break;
        }
        case "get_settings": {
          const accountDetails = data.get_settings;

          if (accountDetails.allow_copiers == 0) {
            socketRef.current.send(
              JSON.stringify({
                set_settings: 1,
                // account_opening_reason:
                //     accountDetails.account_opening_reason,
                // address_city: accountDetails.address_city,
                // address_line_1: accountDetails.address_line_1,
                // address_line_2: accountDetails.address_line_2,
                // address_postcode: accountDetails.address_postcode,
                // address_state: accountDetails.address_state,
                allow_copiers: 1,
                email_consent: accountDetails.email_consent,
                // phone: accountDetails.phone,
                // place_of_birth: accountDetails.place_of_birth,
                preferred_language: accountDetails.preferred_language,
                // request_professional_status:
                //     accountDetails.request_professional_status,
                // tax_identification_number:
                //     accountDetails.tax_identification_number,
                tax_residence: accountDetails.tax_residence,
              })
            );
          } else {
            setMessage(authorizeData);
          }

          break;
        }
        case "set_settings": {
          if (data.set_settings?.allow_copiers === 0) {
            console.log("Copy Disabled");
          } else {
            console.log("Copy Enabled");
          }
          setMessage(authorizeData);

          break;
        }
        default:
          break;
      }
    };

    // Optional: log connection events
    socketRef.current.onopen = () => {
      console.log("WebSocket connected");
      socketRef.current.send(JSON.stringify({ authorize: loginToken }));
    };
    socketRef.current.onerror = (err) => console.error("WebSocket error:", err);
    socketRef.current.onclose = () => console.log("WebSocket closed");

    // Cleanup function
    return () => {
      socketRef.current?.close();
    };
  }, [url, loginToken]);
  if (loginToken == "") return null;

  return message;
}
